"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var requireCoursesFromMap_1 = require("../utils/requireCoursesFromMap");
var combineVerifications_1 = require("../utils/combineVerifications");
var chapter130Courses = require("../tea_data/chapter130");
var mustPassOneOfValidations_1 = require("../utils/mustPassOneOfValidations");
var courseOptionsFromCourseMap_1 = require("../utils/courseOptionsFromCourseMap");
var courseIsSubject_1 = require("../utils/courseIsSubject");
var subjectsMap_1 = require("../subjects_data/subjectsMap");
var publicServicesfromChapter130 = __assign({}, chapter130Courses.E, chapter130Courses.G, chapter130Courses.H, chapter130Courses.J, chapter130Courses.L, chapter130Courses.oneTwentySevenB);
exports.default = function (allCourses, courseMap) {
    var cteOptions = courseOptionsFromCourseMap_1.default(courseMap, publicServicesfromChapter130, 4, "public-service-cte-options");
    var ROTCMap = allCourses
        .filter(courseIsSubject_1.default(subjectsMap_1.subjectMap.rotc))
        .reduce(function (map, c) {
        map[c.course_title] = 1;
        return map;
    }, {});
    var validations = {
        educationAndTraining: {
            options: cteOptions,
            validate: validateCTE(allCourses, "education-and-training", chapter130Courses.E)
        },
        governmentAndPublicAdministration: {
            options: cteOptions,
            validate: validateCTE(allCourses, "government-and-public-administration", chapter130Courses.G)
        },
        healthScience: {
            options: cteOptions,
            validate: validateCTE(allCourses, "health-science", chapter130Courses.H)
        },
        humanServices: {
            options: cteOptions,
            validate: validateCTE(allCourses, "human-services", chapter130Courses.J)
        },
        lawPublicSafetyCorrectionsAndSecurity: {
            options: cteOptions,
            validate: validateCTE(allCourses, "law-public-safety-corrections-and-security", chapter130Courses.L)
        },
        jrotc: {
            options: courseOptionsFromCourseMap_1.default(courseMap, ROTCMap, 4, "rotc-options"),
            validate: requireCoursesFromMap_1.requireSomeCoursesFromMap(allCourses, ROTCMap, "rotc-requirements", 4)
        }
    };
    return validations;
};
var validateCTE = function (allCourses, title, capStoneMap) { return function (courses) {
    if (courses === void 0) { courses = allCourses; }
    var hasFourCreditsFromCourses = requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, publicServicesfromChapter130, "4-same-credits-from-chapter130", 4)();
    var has2FromTheSameClusterValidations = Object.keys(chapter130Courses)
        .map(function (key) { return chapter130Courses[key]; })
        .map(function (req) {
        return requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, req, "requires-two-from-the-same-chapter", 2);
    });
    var has2FromTheSameCluster = mustPassOneOfValidations_1.mustPassOneOf.apply(void 0, [courses].concat(has2FromTheSameClusterValidations))();
    var hasOneFromCluster = requireCoursesFromMap_1.requireSomeCoursesFromMap(courses, capStoneMap, "requires-one-from-" + title, 1)();
    return combineVerifications_1.default([hasFourCreditsFromCourses, has2FromTheSameCluster, hasOneFromCluster], hasFourCreditsFromCourses.coursesNotConsumed, 4, title + "-requirements");
}; };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/public-services/index.js
// module id = 454
// module chunks = 22